import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
const REGEX_ALLOW_NUMBERS_AND_COLON = /[^0-9:]/;

@Directive({
  standalone: false,
  selector: '[appTimeInputMask]',
})
export class TimeInputMaskDirective {
    constructor(@Optional() private ngControl: NgControl) {}

    @HostListener('input', ['$event'])
    onKeyDown(event: KeyboardEvent) {
      const input = event.target as HTMLInputElement;

      // Filter - allows 0-9 and ":" only, sanatizes per keydown
      if (REGEX_ALLOW_NUMBERS_AND_COLON.test(input.value)){
        input.value = input.value.replace(REGEX_ALLOW_NUMBERS_AND_COLON, '');
        this.ngControl?.control?.setValue(input.value, { emitEvent: false });
        return input.value;
      }

      // Format - adjusts the final value's format to 'HH:MM', updates per keydown
      const trimmed = input.value.replace(/\s+/g, '').slice(0, input.value.indexOf(':') == -1 ? 4 : 5);
      if (trimmed.length >= 3) {
        input.value = `${trimmed.slice(0, 2)}:${trimmed.slice(trimmed.indexOf(':') == -1 ? 2 : 3)}`;
        this.ngControl?.control?.setValue(input.value, { emitEvent: false });
        return input.value;
      }

      this.ngControl?.control?.setValue(input.value, { emitEvent: false });
      return input.value;
    }

}